import { render, staticRenderFns } from "./Sns.vue?vue&type=template&id=6014714c&scoped=true&"
import script from "./Sns.vue?vue&type=script&lang=js&"
export * from "./Sns.vue?vue&type=script&lang=js&"
import style0 from "./Sns.vue?vue&type=style&index=0&id=6014714c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6014714c",
  null
  
)

export default component.exports